import { createSelector } from 'reselect';
import * as R from 'ramda';

import { createFilter } from './FilterUtil';

const getItems = state => state.entities.chatsStats.items;
const getFilter = state => state.entities.chatsStats.filter;

const itemMatchesFilter = (i, filter) =>
  !filter || i.name.indexOf(filter) > -1 || i.slug.indexOf(filter) > -1 || companyMatchesFilter(i.company, filter);
const companyMatchesFilter = (c, filter) => !filter || c.name.indexOf(filter) > -1 || c.slug.indexOf(filter) > -1;

export const getChatsFiltered = createSelector([getItems, getFilter], (items, filterValue) => {
  if (!filterValue) {
    return items;
  }
  return R.map(
    c => ({
      ...c,
      projects: R.filter(
        createFilter(filterValue, itemMatchesFilter),
        R.map(p => ({ ...p, company: c }), c.projects || [])
      )
    }),
    items
  );
});



// WEBPACK FOOTER //
// ./src/selectors/ChatsStatsSelector.js